import { IconButton } from '@ds';
import { InfoBanner } from '@ui';
import { MdClose } from 'react-icons/md';
import { useEffect, useState } from 'react';
import { AssignedUsersByGroup, CaseUserGroup } from '@/api/apis/case';

type PrimaryWarningBannerProps = {
  userGroups: CaseUserGroup[];
  assignedEmployees: AssignedUsersByGroup;
};

export const PrimaryWarningBanner = ({ userGroups, assignedEmployees }: PrimaryWarningBannerProps) => {
  const [showPrimaryInfoBanner, setShowPrimaryInfoBanner] = useState<boolean>(false);

  useEffect(() => {
    const showInfoBanner = userGroups.some((group) => {
      const currentGroup = assignedEmployees[group];
      return !!currentGroup && currentGroup.length > 1 && currentGroup.every((user) => !user.isPrimary);
    });

    setShowPrimaryInfoBanner(showInfoBanner);
  }, [assignedEmployees, userGroups]);

  if (!showPrimaryInfoBanner) return null;
  return (
    <InfoBanner className="w-full" iconType="info">
      <div className="flex flex-row gap-2 items-center justify-between">
        <span>
          {`Some roles have multiple representatives. To improve team communication, please consider designating one as
          the 'primary' contact`}
        </span>
        <IconButton
          className="my-1 text-info-10 border-0 bg-none"
          size="xs"
          variant="outline"
          startContent={<MdClose className="h-[25px]! w-[25px]!" />}
          onPress={() => setShowPrimaryInfoBanner(false)}
        />
      </div>
    </InfoBanner>
  );
};
